<template>
	<AnalysisChart
		endpoint="web/get-mortality-analysis"
		data-key="mortality"
		standard-key="standard_mortality"
		series-label="Mortality"
		standard-label="Standard Mortality"
		yaxis-title="Mortality (%)"
	/>
</template>

<script>
import AnalysisChart from "../components/AnalysisChart.vue";

export default {
	components: { AnalysisChart },
};
</script>
